import * as React from 'react';
import { Box, desktopSidebarWidth, Logo, SidebarDrawer } from './index';
import { useIsDesktop } from 'v1/hooks/use-is-media-query';

export const ContentWithSidebar = ({
  sidebarContent,
  mainContent,
  rightSidebarContent,
  openButtonContents,
  closeButtonContents,
  isDark = false,
}: {
  sidebarContent: React.ReactNode;
  mainContent: React.ReactNode;
  rightSidebarContent?: React.ReactNode;
  openButtonContents: JSX.Element;
  closeButtonContents: JSX.Element;
  isDark?: boolean;
}) => {
  const isDesktop = useIsDesktop();

  if (!isDesktop) {
    return (
      <Box sx={{ position: 'relative', width: '100%' }}>
        <Box sx={{ pb: 64 }}>{mainContent}</Box>
        <SidebarDrawer
          OpenButtonContents={openButtonContents}
          CloseButtonContents={closeButtonContents}
          isDark={isDark}
        >
          {sidebarContent}
        </SidebarDrawer>
      </Box>
    );
  } else {
    const logoContainerHeight = '112px';

    return (
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'grid',
          gridTemplateRows: '1fr',
          gridTemplateColumns: `${desktopSidebarWidth} 1fr 300px`,
          '> *': {
            overflowY: 'auto',
            pr: 4,
          },
        }}
      >
        <Box>
          {sidebarContent}
          <Box
            sx={{
              position: 'absolute',
              left: 0,
              bottom: 0,
              pb: 4,
              height: logoContainerHeight,
              display: 'flex',
              alignItems: 'flex-end',
              background: isDark
                ? 'linear-gradient(180deg, rgba(22, 23, 27, 0) 0%, rgba(22, 23, 27, 0.95) 30%)'
                : 'linear-gradient(180deg, rgba(242, 247, 252, 0) 0%, rgba(242, 247, 252, 0.95) 30%)',
            }}
          >
            <Logo color={isDark ? 'white' : 'black'} />
          </Box>
        </Box>
        <Box sx={{ pb: 100 }}>{mainContent}</Box>
        <Box sx={{ pb: 100 }}>{rightSidebarContent}</Box>
      </Box>
    );
  }
};
